import Vue from 'vue';
import $ from 'jquery';


import modelDictionary from '../../assets/js/apidata.json';
import modelDictionaryen from '../../assets/js/apidata_en.json';
import modelDictionaryja from '../../assets/js/apidata_jp.json';

import lightGallery from 'lightgallery';


Vue.mixin({
  data() {
    return {
        viewer:'',
        data00:modelDictionary.location000,
        data01:modelDictionary.location001,
        data02:modelDictionary.location002,
        data03:modelDictionary.location003,
        data04:modelDictionary.location004,
        data05:modelDictionary.location005,
        data06:modelDictionary.location006,
        data07:modelDictionary.location007,

        data00img:modelDictionary.location000img,
        data01img:modelDictionary.location001img,
        data02img:modelDictionary.location002img,
        data03img:modelDictionary.location003img,
        data04img:modelDictionary.location004img,
        data05img:modelDictionary.location005img,
        data06img:modelDictionary.location006img,
        data07img:modelDictionary.location007img,
        datatext:modelDictionary.alltext,
      };
  },
  beforeMount(){
        this.$nextTick(function () {
        
            lightGallery(document.getElementById('lightgallery'), {
                download:false,
                licenseKey : "968A76CD-A1074F6B-ABF96525-95668362",
            });

        })
    },

  methods: {
    closeDirections(){
        $('.closeDirections').on('click', function (e) {
            $('.Directions-menu').removeClass("openDirections");
            $('.Directions-menu').addClass('hideDirections'); 
        });
    },
    openrightmenu(){
        $('.Directions-menu').addClass('openDirections');
        $('.top-half').removeClass('sound0191');
        
    },
    album(){
        $('#lightgallery li').trigger('click');
    },
    video(){
        $('.VideoMenubox').fadeToggle(300);
    },

    allmenubtn(){
       const self = this;
        $('.common-part').removeClass("open");
        if($('.common-part').hasClass("hide"))
        {       
            $('.common-part').removeClass("hide");
            $('.common-part').addClass("open");
            self.menu = true
        }
        else
        {
            $('.common-part').addClass('hide');
        }
    },

    // 圖片
    PicturePath(id) {
        if( id === null  )
        {
            return `./default.png`; 
        }
        else 
        {
            return `./images/${id}`;
        }
    },
    LinklangTw(link) {
        return `../tw/#${link}`;
    },
    LinklangEn(link) {
        return `../en/#${link}`;
    },
    LinklangJa(link) {
        return `../ja/#${link}`;
    },
    IframeMap(iframe) {
        return `${iframe}`; 
    },
    IframeVideo(youtube) {
        return `${youtube}`; 
    },
    // 音訊

    Sounds(mp3) {

        return `./images/sounds/${mp3}`;
        
    },
    link(marker){
        if (marker.id !== 'inf' && marker.id !== 'photo') {
            this.$router.push(`/${marker.id}`); 
        }
  
    }
},

  mounted: function () {
    




    this.$nextTick(function () {


        //alert( this.$route.params.id )

        if( '' === this.$route.path  )
        {
            this.menu = false
            this.$store.commit('SET_location', this.data00[0]);
        }

        if( '/location01' === this.$route.path  )
        {
            this.menu = false
            this.$store.commit('SET_location', this.data01[0]);
        }        

        if( '/location0111' === this.$route.path  )
        {
            this.menu = false
            this.$store.commit('SET_location', this.data01[1]);
        }
        

        if( '/location0112' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data01[2]);
        }
        if( '/location0121' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data01[3]);
        } 
        if( '/location0122' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data01[4]);
        } 
      


        if( '/location02' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data02[0]);
        }  

        if( '/location0211' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data02[1]);
        }
        if( '/location0221' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data02[2]);
        }
        if( '/location0222' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data02[3]);
        }
        if( '/location0231' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data02[4]);
        }
        if( '/location0232' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data02[5]);
        }
        if( '/location0241' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data02[6]);
        }


        if( '/location03' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data03[0]);
        }   
        if( '/location0311' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data03[1]);
        }
        if( '/location0321' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data03[2]);
        }
        if( '/location0331' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data03[3]);
        }



        if( '/location04' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[0]);
        }   
        if( '/location0411' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[1]);
        }   
        if( '/location0421' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[2]);
        }   
        if( '/location0422' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[3]);
        }   
        if( '/location0430' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[4]);
        }  
        if( '/location0431' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[5]);
        }   
        if( '/location0432' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[6]);
        }   
        if( '/location0433' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[7]);
        }   
        if( '/location0434' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[8]);
        }  
        if( '/location0435' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[9]);
        }   
        if( '/location0436' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[10]);
        }   
        if( '/location0437' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[11]);
        }   
        if( '/location0441' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[12]);
        }   
        if( '/location0451' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[13]);
        }  
        if( '/location0452' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[14]);
        }  
        if( '/location0461' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[15]);
        }  
        if( '/location0462' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[16]);
        }  
        if( '/location0471' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[17]);
        }  
        if( '/location0481' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data04[18]);
        }  



    
        if( '/location05' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data05[0]);
        }   
        if( '/location0511' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data05[1]);
        }  

        if( '/location0521' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data05[2]);
        }  
        if( '/location0522' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data05[3]);
        }   
        if( '/location0523' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data05[4]);
        }   
        if( '/location0531' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data05[5]);
        }   


        if( '/location06' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data06[0]);
        } 
        if( '/location0611' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data06[1]);
        } 
        if( '/location0621' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data06[2]);
        } 
        if( '/location0622' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data06[3]);
        } 
        if( '/location0631' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data06[4]);
        } 

        if( '/location07' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data07[0]);
        } 
        if( '/location0711' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data07[1]);
        } 
        if( '/location0721' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data07[2]);
        } 
        if( '/location0722' === this.$route.path  )
        {
            this.$store.commit('SET_location', this.data07[3]);
        } 
  });
 
},
    destroyed(){
        $( ".lg-container" ).remove();
        $('.Directions-menu').removeClass("openDirections");
        $('.Directions-menu').addClass('hideDirections'); 
    }
});


